export function getFullName(participant, fallback_name = '') {
    var _a, _b;
    const firstName = (_a = participant === null || participant === void 0 ? void 0 : participant.usage_first_name) !== null && _a !== void 0 ? _a : participant === null || participant === void 0 ? void 0 : participant.first_name;
    const lastName = (_b = participant === null || participant === void 0 ? void 0 : participant.usage_last_name) !== null && _b !== void 0 ? _b : participant === null || participant === void 0 ? void 0 : participant.last_name;
    if ((firstName == '' || firstName == null) &&
        (lastName == '' || lastName == null)) {
        return `(${fallback_name})`;
    }
    return `${firstName} ${lastName}`;
}
export function getNames(participant) {
    var _a, _b;
    const firstName = (_a = participant === null || participant === void 0 ? void 0 : participant.usage_first_name) !== null && _a !== void 0 ? _a : participant === null || participant === void 0 ? void 0 : participant.first_name;
    const lastName = (_b = participant === null || participant === void 0 ? void 0 : participant.usage_last_name) !== null && _b !== void 0 ? _b : participant === null || participant === void 0 ? void 0 : participant.last_name;
    return [firstName, lastName];
}
export function getFirstNameWithLastNameInitial(participant, fallback_name = 'sans nom') {
    var _a, _b;
    const firstName = (_a = participant === null || participant === void 0 ? void 0 : participant.usage_first_name) !== null && _a !== void 0 ? _a : participant === null || participant === void 0 ? void 0 : participant.first_name;
    const lastName = (_b = participant === null || participant === void 0 ? void 0 : participant.usage_last_name) !== null && _b !== void 0 ? _b : participant === null || participant === void 0 ? void 0 : participant.last_name;
    if ((firstName == '' || firstName == null) &&
        (lastName == '' || lastName == null)) {
        return `(${fallback_name})`;
    }
    return `${firstName} ${lastName[0]}.`;
}
export function getInitials(participant, fallback_name = '') {
    var _a, _b;
    const firstName = (_a = participant === null || participant === void 0 ? void 0 : participant.usage_first_name) !== null && _a !== void 0 ? _a : participant === null || participant === void 0 ? void 0 : participant.first_name;
    const lastName = (_b = participant === null || participant === void 0 ? void 0 : participant.usage_last_name) !== null && _b !== void 0 ? _b : participant === null || participant === void 0 ? void 0 : participant.last_name;
    if ((firstName == '' || firstName == null) &&
        (lastName == '' || lastName == null)) {
        return `(${fallback_name})`;
    }
    return `${firstName[0]}${lastName[0]}`;
}
//# sourceMappingURL=nameHelpers.js.map